const CorporateSettings = () => import('./main.vue')

const meta = {
  requiresAuth: true,
}

export default [
  {
    name: 'corporatesettings.index',
    path: '/corporatesettings',
    component: CorporateSettings,
    meta,
  },
]
